// extracted by mini-css-extract-plugin
export default {"header":"ConfirmStep_header__E1gZf","scrolled":"ConfirmStep_scrolled__em+YK"};